import { render } from "./About.vue?vue&type=template&id=1f0d1af5"
const script = {}
script.render = render

export default script